export default __webpack_public_path__ + "static/media/afeo.09584800.png";